import { getWidthMetrics } from './getWidthMetrics';
import type { Chart } from './types';
import { SplitSortBy } from './types';

export const getSortMetrics = (config: Chart): string[] => {
  if (!('splitSort' in config)) {
    return [];
  }

  const sort = config.splitSort;

  if (sort?.by !== SplitSortBy.value || !sort.metric) {
    return [];
  }

  const alreadyRequested = new Set(
    [
      config.primaryMetric,
      config.secondaryMetric,
      ...getWidthMetrics(config),
    ].filter(Boolean),
  );

  return alreadyRequested.has(sort.metric) ? [] : [sort.metric];
};
